import { render } from "./StoreTargetCreate.vue?vue&type=template&id=589c6722&scoped=true"
import script from "./StoreTargetCreate.vue?vue&type=script&lang=js"
export * from "./StoreTargetCreate.vue?vue&type=script&lang=js"

import "./StoreTargetCreate.vue?vue&type=style&index=0&id=589c6722&scoped=true&lang=css"

import exportComponent from "/Users/avinduhewa/Documents/Projects/bokaklip/payl-firebase/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589c6722"]])

export default __exports__